export default __webpack_public_path__ + "7714a24479dc93ce1db048a389669ca2.svg";